export default {
  'pages.layouts.userLayout.title': 'Hệ thống quản trị Quảng Tân',
  'pages.login.accountLogin.tab': 'Đăng nhập tài khoản',
  'pages.login.accountLogin.errorMessage': 'Sai tên đăng nhập hoặc mật khẩu',
  'pages.login.failure': 'Đăng nhập thất bại, vui lòng thử lại!',
  'pages.login.success': 'Đăng nhập thành công!',
  'pages.login.username.placeholder': 'Tên đăng nhập',
  'pages.login.username.required': 'Vui lòng nhập tên đăng nhập!',
  'pages.login.password.placeholder': 'Mật khẩu',
  'pages.login.password.required': 'Vui lòng nhập mật khẩu!',
  'pages.login.phoneLogin.tab': 'Đăng nhập bằng SĐT',
  'pages.login.phoneLogin.errorMessage': 'Mã xác thực không đúng',
  'pages.login.phoneNumber.placeholder': 'Số điện thoại',
  'pages.login.phoneNumber.required': 'Vui lòng nhập số điện thoại!',
  'pages.login.phoneNumber.invalid': 'Số điện thoại không hợp lệ!',
  'pages.login.captcha.placeholder': 'Mã xác thực',
  'pages.login.captcha.required': 'Vui lòng nhập mã xác thực!',
  'pages.login.phoneLogin.getVerificationCode': 'Lấy mã',
  'pages.getCaptchaSecondText': 'giây',
  'pages.login.rememberMe': 'Ghi nhớ đăng nhập',
  'pages.login.forgotPassword': 'Quên mật khẩu?',
  'pages.login.submit': 'Đăng nhập',
  'pages.login.loginWith': 'Đăng nhập với:',
  'pages.login.registerAccount': 'Đăng ký tài khoản',
  'pages.welcome.link': 'Chào mừng',
  'pages.welcome.alertMessage': 'Các component mạnh mẽ hơn đã được phát hành.',
  'pages.404.subTitle': 'Xin lỗi, trang bạn truy cập không tồn tại.',
  'pages.404.buttonText': 'Về trang chủ',
  'pages.admin.subPage.title': 'Trang này chỉ Admin mới xem được',
  'pages.admin.subPage.alertMessage': 'Umi ui đã được phát hành, chạy npm run ui để trải nghiệm.',
  'pages.searchTable.createForm.newRule': 'Tạo mới',
  'pages.searchTable.updateForm.ruleConfig': 'Cấu hình',
  'pages.searchTable.updateForm.basicConfig': 'Thông tin cơ bản',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Tên',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Vui lòng nhập tên!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Mô tả',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Vui lòng nhập ít nhất 5 ký tự',
  'pages.searchTable.updateForm.ruleDesc.descRules': 'Vui lòng nhập mô tả ít nhất 5 ký tự!',
  'pages.searchTable.updateForm.ruleProps.title': 'Cấu hình thuộc tính',
  'pages.searchTable.updateForm.object': 'Đối tượng giám sát',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Mẫu',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Loại',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Đặt lịch',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Thời gian bắt đầu',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Vui lòng chọn thời gian bắt đầu!',
  'pages.searchTable.titleDesc': 'Mô tả',
  'pages.searchTable.ruleName': 'Tên là bắt buộc',
  'pages.searchTable.titleCallNo': 'Số lần gọi',
  'pages.searchTable.titleStatus': 'Trạng thái',
  'pages.searchTable.nameStatus.default': 'Mặc định',
  'pages.searchTable.nameStatus.running': 'Đang chạy',
  'pages.searchTable.nameStatus.online': 'Trực tuyến',
  'pages.searchTable.nameStatus.abnormal': 'Bất thường',
  'pages.searchTable.titleUpdatedAt': 'Cập nhật lần cuối',
  'pages.searchTable.exception': 'Vui lòng nhập lý do!',
  'pages.searchTable.titleOption': 'Thao tác',
  'pages.searchTable.config': 'Cấu hình',
  'pages.searchTable.subscribeAlert': 'Đăng ký thông báo',
  'pages.searchTable.title': 'Biểu mẫu truy vấn',
  'pages.searchTable.new': 'Thêm mới',
  'pages.searchTable.chosen': 'đã chọn',
  'pages.searchTable.item': 'mục',
  'pages.searchTable.totalServiceCalls': 'Tổng số lần gọi dịch vụ',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Xóa hàng loạt',
  'pages.searchTable.batchApproval': 'Duyệt hàng loạt',
};
